<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Keyboard Shortcuts</h1>
        </template>
        
        <ul>
            <li class="flex items-center py-2 border-b border-gray-light">
               <div class="w-1/4"><span class="bg-primary-lighter rounded p-1 text-sm font-bold">?</span></div>
               <div class="w-3/4"><span>Show keyboard shortcuts</span></div>
            </li>
            <li class="flex items-center py-2 border-b border-gray-light">
               <div class="w-1/4"><span class="bg-primary-lighter rounded p-1 text-sm font-bold">a</span></div>
               <div class="w-3/4"><span>Select all messages</span></div>
            </li>
            <li class="flex items-center py-2 border-b border-gray-light">
               <div class="w-1/4"><span class="bg-primary-lighter rounded p-1 text-sm font-bold">r</span></div>
               <div class="w-3/4"><span>Mark selected messages as reviewed</span></div>
            </li>
            <li class="flex items-center py-2 border-b border-gray-light">
               <div class="w-1/4"><span class="bg-primary-lighter rounded p-1 text-sm font-bold">shift</span></div>
               <div class="w-3/4"><span>Highlight the first message</span></div>
            </li>
            <li class="flex items-center py-2 border-b border-gray-light">
               <div class="w-1/4"><span class="bg-primary-lighter rounded p-1 text-sm font-bold">shift + &darr;</span></div>
               <div class="w-3/4"><span>Highlight the next message</span></div>
            </li>
            <li class="flex items-center py-2 border-b border-gray-light">
               <div class="w-1/4"><span class="bg-primary-lighter rounded p-1 text-sm font-bold">shift + &uarr;</span></div>
               <div class="w-3/4"><span>Highlight the previous message</span></div>
            </li>
            <li class="flex items-center py-2 border-b border-gray-light">
               <div class="w-1/4"><span class="bg-primary-lighter rounded p-1 text-sm font-bold">shift + s</span></div>
               <div class="w-3/4"><span>Select the highlighted message</span></div>
            </li>
            <li class="flex items-center py-2 border-b border-gray-light">
               <div class="w-1/4"><span class="bg-primary-lighter rounded p-1 text-sm font-bold">shift + r</span></div>
               <div class="w-3/4"><span>Mark as reviewed the highlighted message</span></div>
            </li>
            <li class="flex items-center py-2 border-b border-gray-light">
               <div class="w-1/4"><span class="bg-primary-lighter rounded p-1 text-sm font-bold">shift + enter</span></div>
               <div class="w-3/4"><span><strong>Deliver Always</strong> the highlighted message</span></div>
            </li>
            <li class="flex items-center py-2 border-b border-gray-light">
               <div class="w-1/4"><span class="bg-primary-lighter rounded p-1 text-sm font-bold">shift + backspace</span></div>
               <div class="w-3/4"><span><strong>Block</strong> the highlighted message</span></div>
            </li>
        </ul>

        <template v-slot:footer>
            <button class="py-2 px-4 rounded-md bg-primary-lightest" @click="close">Got it.</button>
        </template>
    </modal-component>
</template>

<script>
export default {
    methods: {
        close() {
            this.$emit('close');
        }
    }
}
</script>